export default build =>
    build.query({
        tagTypes: ['photogallery'],
        keepUnusedDataFor: 1,
        query() {
            //console.log("payload",payload)            
            return {
                url: '/school/getPhotoGallery',
                method: 'GET',
                //body: payload,
            };
           
        },
       providesTags: ['photogallery']
    })
